import React from "react";
import styled from "styled-components";

const ModalContent = styled.div`
  padding: 15px;
`;
export default function Header({ children }) {
  return <ModalContent>{children}</ModalContent>;
}
